import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Table/table';

var TbodyBase = function TbodyBase(_a) {
  var children = _a.children,
      className = _a.className,
      isExpanded = _a.isExpanded,
      innerRef = _a.innerRef,
      _a$isEvenStriped = _a.isEvenStriped,
      isEvenStriped = _a$isEvenStriped === void 0 ? false : _a$isEvenStriped,
      _a$isOddStriped = _a.isOddStriped,
      isOddStriped = _a$isOddStriped === void 0 ? false : _a$isOddStriped,
      props = __rest(_a, ["children", "className", "isExpanded", "innerRef", "isEvenStriped", "isOddStriped"]);

  return React.createElement("tbody", Object.assign({
    role: "rowgroup",
    className: css(className, isExpanded && styles.modifiers.expanded, isOddStriped && styles.modifiers.striped, isEvenStriped && styles.modifiers.stripedEven),
    ref: innerRef
  }, props), children);
};

export var Tbody = React.forwardRef(function (props, ref) {
  return React.createElement(TbodyBase, Object.assign({}, props, {
    innerRef: ref
  }));
});
Tbody.displayName = 'Tbody';